import { connect } from 'react-redux';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { resolveHopintoQuery } from '@Pages/Hopinto/HopintoQuery';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { resolveUserAlert, resolveUserAlertHitDetails } from '@Containers/Hopinto/Services/Alert';
import { resolveFullText } from '@Containers/Hopinto/Services/FullText';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import { createRTProject } from '@Pages/Hopinto/HopintoRT';
import { addProjectAction } from '@Pages/RetroSynthesis/RetroSynthesisProjects/actions';
import { proccessBatchFile } from '@Pages/Hopinto/HopintoBatchFile';
import every from 'lodash/every';
import isUndefined from 'lodash/isUndefined';

const resolveHopinto = (history, { addProject }) => {
  const stateParams = Object.fromEntries(new URLSearchParams(history.location.search));
  const _checkParams = (requiredParams) => {
    return every(requiredParams, (reqP) => !isUndefined(stateParams[reqP]));
  };

  const isNewAlert = stateParams.origin === 'email-doc';
  const isNewAlertHitDetails = stateParams.forward === 'switch_from_citation';
  const isNewAlertFullText = stateParams.forward === 'follow_fulltext';
  const newAlertParams = ['alert'];
  const newAlertHitDetailsParams = ['alert', 'context', 'query'];
  const newAlertFullTextParams = ['query', 'context'];

  const batchFileParams = ['file'];
  const rtParams = ['context'];

  // new alerts
  if (isNewAlert) {
    if (isNewAlertHitDetails && _checkParams(newAlertHitDetailsParams)) {
      // hit details
      resolveUserAlertHitDetails(stateParams);
    } else if (isNewAlertFullText && _checkParams(newAlertFullTextParams)) {
      resolveFullText(stateParams);
    } else if (_checkParams(newAlertParams)) {
      // alert
      resolveUserAlert(stateParams);
    } else {
      // default - for view document
      resolveHopintoQuery(stateParams, history.location);
    }
  } else if (_checkParams(batchFileParams)) {
    // batch file hopinto
    proccessBatchFile(stateParams);
  } else if (_checkParams(rtParams) && stateParams.context === 'RT') {
    // RT create project
    createRTProject(stateParams, history, addProject);
  } else {
    // advanced query
    resolveHopintoQuery(stateParams, history.location);
  }
};

// eslint-disable-next-line react/prop-types
export function HopintoContainer({ addProject }) {
  const history = useHistory();

  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    resolveHopinto(history, { addProject });
    // eslint-disable-next-line
  }, []);

  return <SimpleSpinner />;
}

const mapDispatchToProps = {
  addProject: addProjectAction,
};

export default connect(null, mapDispatchToProps)(HopintoContainer);
